import React, { useState } from "react";
import ButtonComponent from "../../ButtonComponent";
import PrescriptionModal from "./PrescriptionModal";
import MedicalRecordsModal from "./MedicalRecordsModal";
import DocumentsModal from "./DocumentsModal";
import CloseVisitModal from "./CloseVisitModal";
import AboutPatientModal from "./AboutPatientModal";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useTranslation } from "react-i18next";
import { COLORS } from "../../../lib/colors";
import { useUserState } from "../../../providers/UserProvider";
import classes from "./index.module.scss";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useActiveRoomActions } from "../../../providers/ActiveRoomProvider";
import { Link } from "react-router-dom";
import CallIcon from "@mui/icons-material/Call";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import SubjectIcon from "@mui/icons-material/Subject";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CameraFrontIcon from "@mui/icons-material/CameraFront";
import PersonPinIcon from "@mui/icons-material/PersonPin";

function Index({
  audienceId,
  visitToken,
  patientVideoCallRequestModal,
  onVideoCall,
  openVoiceCall,
  loadingVideoCall,
  loadingVoiceCall,
}) {
  const { t } = useTranslation();
  const user = useUserState();
  let userType = user?.user_login?.approve;
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [openPrescriptions, setOpenPrescriptions] = useState(false);
  const [openMedicalRecordsModal, setOpenMedicalRecordsModal] = useState(false);
  const [openDocumentsModal, setOpenDocumentsModal] = useState(false);
  const [finishVisitModal, setFinishVisitModal] = useState(false);
  const [openAboutPatientModal, setOpenAboutPatientModal] = useState(false);
  const { setCurrentRoom } = useActiveRoomActions();

  let isMobile = false;
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isMobile = true;
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(false);
  };

  const onSelectPrscription = () => {
    setOpenPrescriptions(true);
  };

  const onSelectMedicalRecordsModal = () => {
    setOpenMedicalRecordsModal(true);
  };
  const onSelectDocumentsModal = () => {
    setOpenDocumentsModal(true);
  };
  const onSelectFinishVisit = () => {
    setFinishVisitModal(true);
  };
  const onSelectAboutPatientModal = () => {
    setOpenAboutPatientModal(true);
    handleClose();
  };

  const renderMenu = () => {
    if (userType === "doctor") {
      return (
        <div>
          <ButtonComponent
            backgroundColor={COLORS.warning}
            icon={<CloseIcon />}
            onClick={onSelectFinishVisit}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.endTheVisit")}
          </ButtonComponent>

          {!isMobile && (
            <>
              <ButtonComponent
                backgroundColor={COLORS.purple}
                icon={<DescriptionIcon />}
                onClick={onSelectPrscription}
                className={classes.headerBtn}
              >
                {t("components.AppointmentRoom.RoomHeader.prscription")}
              </ButtonComponent>
              <ButtonComponent
                backgroundColor={COLORS.purple}
                icon={<SubjectIcon />}
                onClick={onSelectMedicalRecordsModal}
                className={classes.headerBtn}
              >
                {t("components.AppointmentRoom.RoomHeader.medicalRecords")}
              </ButtonComponent>
            </>
          )}
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<AssignmentIcon />}
            onClick={onSelectDocumentsModal}
            className={classes.headerBtn}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.documents")}
          </ButtonComponent>
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<CallIcon />}
            onClick={openVoiceCall}
            className={classes.headerBtn}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.phoneCall")}
          </ButtonComponent>
          <ButtonComponent
            backgroundColor={COLORS.purple}
            icon={<CameraFrontIcon />}
            onClick={onVideoCall}
            className={classes.headerBtn}
            loading={loadingVideoCall}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.videoCall")}
          </ButtonComponent>
        </div>
      );
    }

    if (userType === "user") {
      return (
        <div>
          <ButtonComponent
            backgroundColor={COLORS.primary}
            textColor={COLORS.purple}
            icon={<DescriptionIcon />}
            onClick={onSelectPrscription}
            className={classes.headerBtn}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.prscription")}
          </ButtonComponent>
          <ButtonComponent
            backgroundColor={COLORS.primary}
            textColor={COLORS.purple}
            icon={<CameraFrontIcon />}
            onClick={patientVideoCallRequestModal}
            className={classes.headerBtn}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.requestVideoCall")}
          </ButtonComponent>
          <ButtonComponent
            backgroundColor={COLORS.yellow}
            textColor={COLORS.purple}
            icon={<PersonPinIcon />}
            onClick={onSelectPrscription}
            className={classes.headerBtn}
          >
            {isMobile
              ? ""
              : t("components.AppointmentRoom.RoomHeader.smsToDoctor")}
          </ButtonComponent>
        </div>
      );
    }
  };

  const renderMoreMenuItems = () => {
    if (userType === "doctor") {
      return (
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={onSelectAboutPatientModal}>
            {t("components.AppointmentRoom.RoomHeader.aboutThePatient")}
          </MenuItem>
          <MenuItem onClick={null}>
            {t("components.AppointmentRoom.RoomHeader.smsToPatient")}
          </MenuItem>
          <MenuItem onClick={null}>
            {t("components.AppointmentRoom.RoomHeader.patientsWhatsApp")}
          </MenuItem>

          {isMobile && (
            <>
              <MenuItem onClick={onSelectPrscription}>
                {t("components.AppointmentRoom.RoomHeader.prscription")}
              </MenuItem>
              <MenuItem onClick={onSelectMedicalRecordsModal}>
                {t("components.AppointmentRoom.RoomHeader.medicalRecords")}
              </MenuItem>
            </>
          )}
        </Menu>
      );
    }

    if (userType === "user") {
      return (
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={onSelectDocumentsModal}>
            {t("components.AppointmentRoom.RoomHeader.documents")}
          </MenuItem>
          <MenuItem onClick={null}>
            {t("components.AppointmentRoom.RoomHeader.smsToDoctor")}
          </MenuItem>
          <MenuItem onClick={null}>
            {t("components.AppointmentRoom.RoomHeader.cancelTheVisit")}
          </MenuItem>
        </Menu>
      );
    }
  };

  return (
    <div className={classes.mainContainer}>
      {isMobile && (
        <Link to={"/dashboard"}>
          <ButtonComponent
            width="5%"
            icon={<ArrowBackIcon />}
            onClick={() => {
              setCurrentRoom("");
            }}
          ></ButtonComponent>
        </Link>
      )}
      {renderMenu()}

      <ButtonComponent
        width="5%"
        icon={<ArrowDropDownIcon />}
        onClick={handleClick}
      ></ButtonComponent>

      {renderMoreMenuItems()}
      <PrescriptionModal
        handleOpenPrescriptions={openPrescriptions}
        handleClosePrescriptions={() => setOpenPrescriptions(false)}
        audienceId={audienceId}
        visitToken={visitToken}
      />
      <MedicalRecordsModal
        handleOpenMedicalRecords={openMedicalRecordsModal}
        handleCloseMedicalRecords={() => setOpenMedicalRecordsModal(false)}
        audienceId={audienceId}
        visitToken={visitToken}
      />
      <DocumentsModal
        handleOpenDocuments={openDocumentsModal}
        handleCloseDocuments={() => setOpenDocumentsModal(false)}
        audienceId={audienceId}
        visitToken={visitToken}
      />
      <CloseVisitModal
        handleOpenCloseVisit={finishVisitModal}
        handleCloseCloseVisit={() => setFinishVisitModal(false)}
      />
      <AboutPatientModal
        handleOpenAboutPatient={openAboutPatientModal}
        handleCloseAboutPatient={() => setOpenAboutPatientModal(false)}
      />
    </div>
  );
}

export default Index;
